import { FC } from 'react'
import { ModalWithButton } from '@lifedot/components/ModalWithButton'
import { Button } from '@lifedot/atoms/Button'
import { SimpleSelectPanel } from '@lifedot/components/SelectPanels'
import { useCitiesModal } from './dependencies'
import { Condition } from '@lifedot/constants/searchChoices'
import { css } from '@emotion/react'
import { typography } from '@lifedot/styles/typography'
import { palette } from '@lifedot/styles/palette'
import CloseIcon from '@material-ui/icons/Close'

const styles = {
  button: css({
    paddingRight: 12
  }),
  close: css({
    background: 'none',
    color: palette.gray5
  })
}

interface CitiesModalProps {
  prefecture: string
  regionName: string
  regionCode: string
  condition: Condition
}

export const CitiesModal: FC<CitiesModalProps> = (props) => {
  return (
    <ModalWithButton
      button={
        <Button
          mainText={
            <span css={[typography.textM, styles.button]}>
              {props.regionName}
            </span>
          }
          variant="secondary"
        />
      }
    >
      {({ handleClose }) => <ModalInner {...props} handleClose={handleClose} />}
    </ModalWithButton>
  )
}

interface ModalInnerProps extends CitiesModalProps {
  handleClose: () => void
}

const ModalInner: FC<ModalInnerProps> = ({
  prefecture,
  condition,
  regionName,
  regionCode,
  handleClose
}) => {
  const [{ items, disabled }, { onChange, onSubmit }] = useCitiesModal(
    prefecture,
    condition,
    regionCode
  )

  return (
    <SimpleSelectPanel
      items={items}
      title="市区町村を選ぶ"
      allSelectorLabel={`${regionName}の全て`}
      submitButtonText="選択した市区町村で検索"
      handleSubmit={onSubmit}
      submitDisabled={disabled}
      onChange={onChange}
      headerTools={
        <button css={styles.close} onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </button>
      }
    />
  )
}
